import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { Order, OrderListResponse, OrderRequest } from './types'


export const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'orderId') {
        return ['id', item[1]?.toLowerCase()]
      } else if (item[0] === 'updatedAt' || item[0] === 'createdAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const ordersListMounted = createEvent<OrderRequest>()

export const getOrderList = fx<OrderRequest, OrderListResponse>({
  method: 'GET',
  url: `/nova/order`,
})

export const $orders = restore<Order[]>(
  getOrderList.doneData.map((a) => {
    return a.body.items.map((item) => {
      return {...item, userId: item.userId != null ? +item.userId : -1}
    })
  }),
  [],
)

export const $totalCountOfOrders = restore(
  getOrderList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: ordersListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    if (orderBy == 'orderId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }
    // @ts-ignore
    if (orderBy != '') {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }
    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status' ||
            key === 'backendStatus'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getOrderList,
})
